import resources from '@/crud/form/form'

import data from './data'
import methods from './methods'
import validations from './validations'
import components from './components'
import mounted from './mounted'

export default {
  data,
  methods,
  validations,
  components,
  mounted,
  mixins: [resources],
  resourcePath: '/v1/auth/register'
}



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/index.js